module.exports = __webpack_public_path__ + "img/inkie1.b939a861.gif";